<template>
  <div>
    <div class="mb-2 d-flex justify-space-between">
      <span>
        {{ item.time.start | formatDate }} {{ item.time.start | formatTime }} -
        {{ item.time.end | formatTime }}
      </span>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            @click="addNewSchedule"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            <v-icon> mdi-plus-circle-outline </v-icon>
          </v-btn>
        </template>
        <span>Add New Student Schedule</span>
      </v-tooltip>
    </div>

    <div v-for="schedule in studentSchedules" :key="schedule.id">
      <StudentScheduleItem
        :schedule="schedule"
        :teachers="teachers"
        :classrooms="classrooms"
        :teacherId="teacher ? teacher.id : null"
        :uuID="uuID"
      />
    </div>

    <div class="my-4 text-center">
      <v-btn color="blue darken-1" text @click="$emit('on-close')">
        Close
      </v-btn>
    </div>
  </div>
</template>

<script>
import dialogMixin from './dialogMixin';

import { EventBus } from "@/EventBus.js";
import { mapGetters, mapActions } from "vuex";
const StudentScheduleItem = () =>
  import("@/components/student/StudentScheduleItem.vue");
import { openNewStudentSchedule } from "@/components/schedule/eventHandler.js";

export default {
  mixins: [dialogMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  components: { StudentScheduleItem },
  computed: {
    ...mapGetters(["isAppLoading", "globalCenter"]),

    teacher() {
      if (this.item.teacherId) {
        return {
          id: this.item.teacherId,
          name: this.item.teacherName,
          firstName: this.item.teacherFirstName,
          lastName: this.item.teacherLastName,
        };
      } else {
        return null;
      }
    },
    studentSchedules() {
      if (this.item.details) {
        const schedules = [...this.item.details].sort((a, b) =>
          a.studentFirstName.localeCompare(b.studentFirstName)
        );
        return schedules;
      } else {
        return [];
      }
    },
  },
  created() {
    EventBus.$on("reload-dialog", (uuID, instructions) => {
      //The containing dialog is the main component
      if(uuID == this.uuID){
        const action = instructions.action;
        const schedule = instructions.schedule;
        if(action == 'deleted'){
          this.onDeleted(schedule.id)
        }
        if(action == 'updated'){
          const originalSchedule = instructions.originalSchedule;
          this.onUpdated(originalSchedule, schedule)
        }
        else if(action == 'added'){
          this.onAdded(schedule)
        }
      }
    })
  },
  beforeDestroy() {
    // to avoid memory leaks
    EventBus.$off("reload-dialog");
  },
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage", "clearMessage"]),

    addNewSchedule() {
      openNewStudentSchedule( {teacher: this.teacher, parentID: this.uuID} );
    },
    onDeleted(id){
      const deleteIndex = this.item.details.findIndex(d => d.id == id)
      this.item.details.splice(deleteIndex, 1);

      //Close dialog if no schedule left to show.
      if(this.item.details && this.item.details.length < 1){
        this.$emit('on-close');
      }
    },
    onAdded(schedule){
      this.item.details.push(schedule)
    },
    onUpdated(originalSchedule, newSchedule){
      const deleteIndex = this.item.details.findIndex(d => d.id == originalSchedule.id)
      this.item.details.splice(deleteIndex, 1);

      if(newSchedule){
        this.item.details.push(newSchedule)
      }
    },
  },
};
</script>

<style scoped>
.schedule-container {
  border: 1px solid #ccc;
  margin-bottom: 20px;
  padding: 20px;
}
</style>
